<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form class="formborder" #df="ngForm" novalidate>
    <div class="row m-0 col-md-12 p-0">
      <div class="col-md-2">
        <span class="required-lable"> Select Report</span>
        <select name="SelectReport" id="selectedReport" class="form-control input-text-css" [(ngModel)]="selectedReport"
          (change)="changeHeaderTitle()" #refselectedReport="ngModel" required [ngClass]="{
            'is-invalid': df.submitted && refselectedReport.invalid,
            'alert-warning':
              refselectedReport.invalid &&
              (refselectedReport.dirty ||
                refselectedReport.touched ||
                refselectedReport.untouched)
          }">
          <option [ngValue]="null" selected>Select Report</option>
          <option *ngFor="let item of reportData" [ngValue]="item">
            {{ item.Report_Name }}
          </option>
        </select>
      </div>
      <div *ngIf="selectedReport?.From_Date" class="col-md-2">
        <span>From Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker" dateConvert required placeholder="DD/MM/YYYY" name="FromDate" id="FromDate"
            #refFromdate="ngModel" class="form-control input-text-css" required [(ngModel)]="FromDate" [max]="ToDate" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div *ngIf="selectedReport?.To_Date" class="col-md-2">
        <span>To Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker2" dateConvert [min]="FromDate" placeholder="DD/MM/YYYY" name="ToDate"
            id="ToDate" #refTodate="ngModel" class="form-control input-text-css" required [(ngModel)]="ToDate"
            [min]="FromDate" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2 pr-0" *ngIf="selectedReport?.Report_Name === 'DV Deduction'">
        <span>Branch</span>
        <select name="BranchId" id="BranchId" #refBranchId="ngModel" [(ngModel)]="BranchId" (change)="onBranchChange()"
          class="form-control input-text-css">

          <option value="">Select Branch</option>
          <option *ngFor="let branch of BranchesList" [value]="branch.BranchId">
            {{ branch.Branch_Name }}
          </option>
        </select>
      </div>
      <div class="col-md-1">
        <button class="mt-3 btn font-size-12 button-btn" [disabled]="!df.form.valid" (click)="onReportSearch()">
          Search
        </button>
      </div>
      <div class="col-md-4 mt-3" *ngIf="dataSource.data.length > 0">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch" placeholder="What're you searching for?"
                class="form-control border-0 bg-light" />
              <div class="input-group-append">
                <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
  <div class="table-responsive mt-3" *ngIf="dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matTableExporter
      #exporter1="matTableExporter">
      <!-- <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ (paginator.pageIndex * paginator.pageSize) + i + 1 }}
              </td>
            </ng-container> -->

      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ column }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{'total-row': isTotalRow(row),'date-range-row': isDateInRange(row),  'negative-xirr': isNegativeXirr(row) }">
      </tr>
    </table>

  </div>
  <div *ngIf="dataSource.data.length === 0 && !showSpinner">
    <p>No data available for the selected report.</p>
  </div>
  <div *ngIf="dataSource.data.length > 0" class="row m-0 align-items-center formborder " style="background: #fff">
    <div class="col-md-4 p-1 pb-2 pt-2">
      <button class="btn font-size-12 button-btn" (click)="exportToExcel()">
        <i class="fa fa-file-export mr-1" style="font-size: medium;"></i>
        Export
      </button>

    </div>
    <mat-paginator [pageSizeOptions]="[20, 50]" showFirstLastButtons></mat-paginator>
  </div>


</div>